import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RegistroVentasService } from '../../registro/Services/registro-ventas.service';
import { ResultObject, UsersData } from '../../applicationinfraestructure/interfaces/userData';
import { Router } from '@angular/router';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css']
})
export class EmailVerificationComponent implements OnInit {

  emailForm : FormGroup
  constructor(private formBuilder:FormBuilder,
    public dialogRef: MatDialogRef<EmailVerificationComponent>,
    @Inject(MAT_DIALOG_DATA) public user : UsersData,
    private registroServicios: RegistroVentasService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.initForm()
  }

  initForm(){
    this.emailForm = this.formBuilder.group({
      email:['',[Validators.required,Validators.email]],
      emailConfirm:['',[Validators.required,Validators.email]]
    },{validators: this.emailsMatchValidator})
  }

  emailsMatchValidator(group: AbstractControl): ValidationErrors  {
    const email = group.get('email')?.value;
    const confirmEmail = group.get('emailConfirm')?.value;
    return email === confirmEmail ? { emailsMismatch: false } : { emailsMismatch: true };
  }

  validateEmail(field:string, type:string){
    if (type === 'emailsMismatch') {
      return this.emailForm.hasError(type)
    }
   return this.emailForm.get(field).hasError(type)
  }
  registerEmail(){
    this.registroServicios.verificarEmailUsuarioMarca(this.user.email,this.emailForm.get('emailConfirm').value).subscribe(
      resolve => {
        console.log("juanda")
          if (resolve!= null) {
            this.router.navigate(['/inicio'], {
              queryParams: {
                login: 'marca',
                tipoUsuario: this.user.tipoUsuario
              }
            }
            );
            this.dialogRef.close()
          }

      },
      (error: ErrorResponse) => {
        console.log(error);
      }
    );
  }

}